
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { UserProps } from '../store/user'
import { GlobalDataProps } from '@/store'

export default defineComponent({
  name: 'UserProfile',
  setup() {
    const router = useRouter()
    const store = useStore<GlobalDataProps>()
    const user = computed(() => store.state.user as UserProps)

    const goUserSetting = () => {
      router.push({ name: 'setting', params: { id: user.value.data._id as string } })
    }
    const logout = () => {
      store.commit('logout')
      message.success('退出登录成功', 2)
      router.push({ name: 'login' })
    }
    return {
      user,
      logout,
      goUserSetting
    }
  }
})
